import { type FC } from 'react'

import { type DirectContactFormLoggedOutNotificationType } from '../../../model/directContactFormAccessorGetLoggedOutNotification'

import { DirectContactFormCopaymentExemptionNotification } from './DirectContactFormCopaymentExemptionNotification'
import { DirectContactFormDoctorOrderNotification } from './DirectContactFormDoctorOrderNotification'
import { DirectContactFormLoggedOutSubjectNotification } from './DirectContactFormLoggedOutSubjectNotification'

export const DirectContactFormLoggedOutNotification: FC<{
  isCopaymentExemption: boolean
  isDoctorOrder: boolean
  isLoggedIn: boolean
  notificationType?: DirectContactFormLoggedOutNotificationType
}> = ({
  isCopaymentExemption,
  isDoctorOrder,
  isLoggedIn,
  notificationType,
}) => {
  if (isDoctorOrder) {
    return <DirectContactFormDoctorOrderNotification isLoggedIn={isLoggedIn} />
  }

  if (isCopaymentExemption) {
    return (
      <DirectContactFormCopaymentExemptionNotification
        isLoggedIn={isLoggedIn}
      />
    )
  }

  if (!notificationType) {
    return null
  }

  return (
    <DirectContactFormLoggedOutSubjectNotification
      notificationType={notificationType}
    />
  )
}
